import _ from 'lodash';
import axios from "../../axios";

const state = {
  keys: [
    {
      id: 'ut',
      title: 'نوع کاربری',
      icon: 'icon-user',
      iconPack: 'feather'
    },
    {
      id: 'status',
      title: 'وضعیت سفارش',
      icon: 'icon-user',
      iconPack: 'feather'
    },
  ],
  loading: false,
  rows: [
    {id: 1, key: 'ut', val: 'نوع اول'}
  ]
};
const mutations = {
  ADD_ITEM(state, data) {
    console.log("data ==> ", data);
    state.rows.push(data);
  },
  INJECT(state , {rows , keys}){
    state.rows = rows || [];
    state.keys = keys || [];
  },
  LOADING(state, data) {
    state.loading = data;
  },
  EDIT_ROW(state, data) {
    if (data.delete) {
      console.log("data.row ==> ", data.row);
      console.log("data ==> ", data);
      state.rows = _.without(state.rows, _.find(state.rows, (item) => item.val == data.row.val));
    } else {
      state.rows[data.index] = data.row;
    }
  }
};
const actions = {
  async init({commit}){
    commit('LOADING', true);
    try {
      let res = await axios.get('http://api.doringold.com/admin/config/statics');
      console.log("res ==> " , res);
      commit('INJECT' , res.data);
    } catch (e) {

    } finally {
      commit('LOADING', false);
    }
  },
  async save({commit ,state}, data) {
    commit('LOADING', true);
    try {
      let res = await axios.post('http://api.doringold.com/config/statics' , state.rows);

    } catch (e) {

    } finally {
      commit('LOADING', false);
    }
  }
};
const getters = {};


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
